// extracted by mini-css-extract-plugin
export default {"header":"MobileHeader_header__2bXpU","headerTitle":"MobileHeader_headerTitle__0wWhH","hiddenPlaceholderBackBtn":"MobileHeader_hiddenPlaceholderBackBtn__sUEl1"};